import {utils} from './common/core';
import {sxhr, sxhrHeaders, sxhrRequest} from 'fire-wind-water/sxhr';

sxhrHeaders('Content-Type', 'text/plain');
sxhrRequest((config) => {
  return config;
});

export class Data {
  constructor(url) {
    this.url = url;
  }

  JsonParamsCallback() {
  }

  setDataUrl(url) {
    this.url = url;
  }

  ajax(json) {
    'use strict';
    var settings = {   //默认参数
      url: '',        //请求的URL
      data: ''       //请求的数据
    };
    utils.extend(settings, json);
    return sxhr.post(settings.url, settings.data);
  }

  getJsonParams(info) {
    var o = {
      _cache_refresh: 0,
      _cache_timeout: 300,
      _cache_with_cached: 1
    };
    utils.extend(info, o);
    this.ajax({
      url: this.url + '/api/common/jsonParams/get',
      data: info
    }).then((res) => {
      var data = res.data.body;
      this.JsonParamsCallback(data);
    });
  }
}
